var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 68,
    height: 47.997,
    viewBox: "0 0 68 47.997",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_139",
    x: 0,
    y: 10,
    width: 68,
    height: 37.997,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_233",
    "data-name": "Group 233",
    transform: "translate(-345 -256)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M4.582,0H45.651A4.186,4.186,0,0,1,50,4V22.625a4.186,4.186,0,0,1-4.349,4H4.582a4.186,4.186,0,0,1-4.349-4V4A4.186,4.186,0,0,1,4.582,0Z",
    transform: "translate(354 256)",
    fill: "rgba(0,6,60,0.85)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 345, 256)",
    filter: "url(#Path_139)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_139-2",
    "data-name": "Path 139",
    d: "M4.255,0H45.745A4.353,4.353,0,0,1,50,4.444V15.553A4.353,4.353,0,0,1,45.745,20H4.255A4.353,4.353,0,0,1,0,15.553V4.444A4.353,4.353,0,0,1,4.255,0Z",
    transform: "translate(9 16)",
    fill: "#00063c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_38",
    "data-name": "Path 38",
    transform: "translate(-5764.823 -53.095)",
    fill: "#66cb35",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6115.49365234375 335.9136047363281 L 6115.49365234375 333.5645751953125 L 6115.49365234375 318.4719848632812 L 6115.49365234375 316.1229553222656 L 6117.18701171875 317.7511901855469 L 6125.0341796875 325.2974548339844 L 6125.78369140625 326.0182495117188 L 6125.0341796875 326.7390441894531 L 6117.18701171875 334.2853698730469 L 6115.49365234375 335.9136047363281 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6116.49365234375 318.4719848632812 L 6116.49365234375 333.5645751953125 L 6124.3408203125 326.0182495117188 L 6116.49365234375 318.4719848632812 M 6116.4931640625 316.471923828125 C 6117.00048828125 316.471923828125 6117.5 316.6648864746094 6117.8798828125 317.0303955078125 L 6125.72705078125 324.57666015625 C 6126.119140625 324.9537353515625 6126.3408203125 325.4742736816406 6126.3408203125 326.0182495117188 C 6126.3408203125 326.5622253417969 6126.119140625 327.082763671875 6125.72705078125 327.4598388671875 L 6117.8798828125 335.0061645507812 C 6117.5 335.3716125488281 6117.00048828125 335.5646057128906 6116.4931640625 335.5646057128906 C 6116.22900390625 335.5646057128906 6115.962890625 335.5122985839844 6115.71044921875 335.4047546386719 C 6114.97265625 335.0906982421875 6114.49365234375 334.3663940429688 6114.49365234375 333.5645751953125 L 6114.49365234375 318.4719848632812 C 6114.49365234375 317.670166015625 6114.97265625 316.9458618164062 6115.71044921875 316.6317749023438 C 6115.962890625 316.5242614746094 6116.22900390625 316.471923828125 6116.4931640625 316.471923828125 Z",
    stroke: "none",
    fill: "#f4f4f3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartMarker);
export default __webpack_public_path__ + "static/media/start_marker.0995ed610c4e39a94a0aa77f4eb5e177.svg";
export { ForwardRef as ReactComponent };